<template>
  <div class="product__extra" v-if="metafieldExtraProductsHandle.length">
    <template
      v-for="(handle, index) in metafieldExtraProductsHandle"
      :key="index"
    >
      <ProductVariantsExtra :product-handle="handle" />
    </template>
  </div>
</template>
<script lang="ts" setup>
import useProductStore from '@/store/product'
import ProductVariantsExtra from './ProductVariantsExtra.vue'

import { computed } from 'vue'

const productStore = useProductStore()

const METAFIELD_NAME_SPACE_CUSTOM = 'custom'
const METAFIELD_KEY_EXTRA_PRODUCTS_HANDLE = 'extra_products_handle'

const metafieldExtraProductsHandle = computed(() => {
  const extraProductsHandle = productStore.product?.metafields?.find(
    (item) =>
      item &&
      item.namespace == METAFIELD_NAME_SPACE_CUSTOM &&
      item.key == METAFIELD_KEY_EXTRA_PRODUCTS_HANDLE
  )
  if (!extraProductsHandle) return []
  return JSON.parse(extraProductsHandle.value)
})
</script>
